/* global axios */
import ApiClient from './ApiClient';

class WorkforceAPI extends ApiClient {
  constructor() {
    super('workforce', { apiVersion: 'v3', accountScoped: true });
  }

  getSchedules(params = {}) {
    return axios.get(`${this.url}/schedules`, { params });
  }

  createSchedule(payload) {
    return axios.post(`${this.url}/schedules`, { schedule: payload });
  }

  updateSchedule(id, payload) {
    return axios.patch(`${this.url}/schedules/${id}`, { schedule: payload });
  }

  deleteSchedule(id) {
    return axios.delete(`${this.url}/schedules/${id}`);
  }

  getScheduleExceptions(params = {}) {
    return axios.get(`${this.url}/schedule_exceptions`, { params });
  }

  createScheduleException(payload) {
    return axios.post(`${this.url}/schedule_exceptions`, {
      schedule_exception: payload,
    });
  }

  updateScheduleException(id, payload) {
    return axios.patch(`${this.url}/schedule_exceptions/${id}`, {
      schedule_exception: payload,
    });
  }

  deleteScheduleException(id) {
    return axios.delete(`${this.url}/schedule_exceptions/${id}`);
  }

  getAttendanceLogs(params = {}) {
    return axios.get(`${this.url}/attendance`, { params });
  }

  getAttendanceSettings() {
    return axios.get(`${this.url}/attendance_settings`);
  }

  updateAttendanceSettings(payload) {
    return axios.patch(`${this.url}/attendance_settings`, {
      attendance_settings: payload,
    });
  }

  updateAttendanceSession(id, payload) {
    return axios.patch(`${this.url}/attendance/${id}`, {
      attendance: payload,
    });
  }

  checkIn(payload) {
    return axios.post(`${this.url}/attendance/check_in`, payload);
  }

  checkOut(payload) {
    return axios.post(`${this.url}/attendance/check_out`, payload);
  }

  startBreak(payload) {
    return axios.post(`${this.url}/attendance/start_break`, payload);
  }

  endBreak(payload) {
    return axios.post(`${this.url}/attendance/end_break`, payload);
  }

  forceClose(payload) {
    return axios.post(`${this.url}/attendance/force_close`, payload);
  }

  getLiveStatus(params = {}) {
    return axios
      .get(`${this.url}/live_status`, { params })
      .then(response => response.data);
  }

  getSelfStatus() {
    return axios.get(`${this.url}/self/status`).then(response => response.data);
  }

  getSelfAttendance(params = {}) {
    return axios
      .get(`${this.url}/self/attendance`, { params })
      .then(response => response.data);
  }

  getSelfSchedule(params = {}) {
    return axios
      .get(`${this.url}/self/schedule`, { params })
      .then(response => response.data);
  }

  getAssignmentRules() {
    return axios.get(`${this.url}/assignment_rules`);
  }

  createAssignmentRule(payload) {
    return axios.post(`${this.url}/assignment_rules`, {
      assignment_rule: payload,
    });
  }

  updateAssignmentRule(id, payload) {
    return axios.patch(`${this.url}/assignment_rules/${id}`, {
      assignment_rule: payload,
    });
  }

  deleteAssignmentRule(id) {
    return axios.delete(`${this.url}/assignment_rules/${id}`);
  }

  getReassignmentCandidates(params = {}) {
    return axios.get(`${this.url}/reassignments`, { params });
  }

  createReassignment(payload) {
    return axios.post(`${this.url}/reassignments`, payload);
  }

  trackActivity(kind = 'interaction') {
    return axios.post(`${this.url}/track_activity`, {
      kind,
      timestamp: new Date().toISOString(),
    });
  }
}

export default new WorkforceAPI();
